import { log } from './log';

export function resetFormInstance()
{
    log('info', 'lifecycle::resetFormInstance');
}
